module.exports = __webpack_public_path__ + "img/smiley_1.dda77379.svg";